import script from "./MailContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MailContent.vue?vue&type=script&setup=true&lang=js"

import "./MailContent.vue?vue&type=style&index=0&id=6af91236&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af91236"]])

export default __exports__